/**
 * 2019/6/12.
 * 作者:yangyl
 *功能: 客户人员管理模块
 */
export default {
  $getway: 'sysapi',
  getUserList: 'user/listGuestUser',
  listGuestRole: 'user/listGuestRole',
  getUserDetail: 'user/detailGuestUser',
  saveUser: 'user/saveGuestUser',
  getDepartList: 'user/listGuestDepart',
  //未修改地址==用户管理下
  deleteUser: 'user/delete',
  saveUserComponent: 'UserComponent/save',
  getUserComponentDetail: 'UserComponent/detail',
  updateStateByPrimaryKey: 'user/open',
  getUserMenuList: 'authority/selectAuthorityByUserId',
  getUserByFunctionResource: 'authority/selectAuthorityByFunctionId'
};
